export const showKBankEmbedUI = ({
  ref_id,
  merchant_id,
  orderId,
  apiKey,
  amount,
  paymentMethods = 'card',
  currency = 'THB',
  scriptUrl = 'https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js',
  endpoint = '/checkout',
  smartpayId = null,
  smartpayTerm = null,
}) => {
  const attributes = {
    mid: merchant_id,
    apikey: apiKey,
    amount: amount,
    currency: currency,
    paymentMethods: paymentMethods,
    showButton: false,
    smartpayId: smartpayId,
    term: smartpayTerm,
    orderId: orderId,
  }
  setValueNull(attributes)

  // removeElement('payment-container')
  // removeElement('kbank')
  // removeElement('kbank-script')

  if (!document.getElementById('form-kbank')) {
    const form = document.createElement('form')
    const script = document.createElement('script')
    const input = document.createElement('input')

    form.method = 'POST'
    form.action = endpoint
    form.id = 'form-kbank'

    input.type = 'hidden'
    input.name = 'ref_id'
    input.value = ref_id
    input.id = 'ref_id'

    const t = new Date()
    script.id = 'kbank-script'
    script.src = `${scriptUrl}?${t.toString()}`
    script.type = 'text/javascript'

    Object.keys(attributes).map(k => {
      const val = attributes[k]
      if (val !== null) {
        script.dataset[k] = attributes[k]
      }
    })

    form.appendChild(script)
    form.appendChild(input)
    document.body.appendChild(form)
    $callUtilSuccess()
  } else {
    const form = document.getElementById('form-kbank')
    form.action = endpoint
    const input = document.getElementById('ref_id')
    input.value = ref_id

    const script = document.getElementById('kbank-script')
    Object.keys(attributes).map(k => {
      const val = attributes[k]
      if (val !== null) {
        script.dataset[k] = attributes[k]
      }
    })

    window.KPayment.show()
  }
}

export const $callUtilSuccess = () => {
  if (window.KPayment) {
    try {
      window.KPayment.create()
      window.KPayment.show()
      return true
    } catch (e) {
      return false
    }
  }

  //retry
  setTimeout($callUtilSuccess, 1000)
}

export const setValueNull = value => {
  window.KPayment?.setPublickey(value.apikey)
  window.KPayment?.setAmount(value.amount)
  window.KPayment?.setCurrency(value.currency)
  window.KPayment?.setPaymentMethods(value.paymentMethods)
  window.KPayment?.setMid(value.mid)
  window.KPayment?.setSmartpayId(value?.smartpayId)
  window.KPayment?.setOrderId(value?.orderId)
  window.KPayment?.setTerm(value?.term)
  window.KPayment?.setLang('en')
}

// function removeElement(id) {
//   var elem = window.document.getElementById(id)
//   if (elem) {
//     try {
//       console.log('removeElement')
//       elem.parentElement.removeChild(elem)
//       elem.parentNode.removeChild(elem)
//       console.log('removeElement 2')
//     } catch {
//       try {
//         elem.parentNode.removeChild(elem)
//       } catch {
//         return
//       }
//     }
//   } else {
//     elem = window.document.getElementsByClassName(id)
//     try {
//       elem.parentElement.removeChild(elem)
//       elem.parentNode.removeChild(elem)
//     } catch {
//       try {
//         elem.parentNode.removeChild(elem)
//       } catch {
//         return
//       }
//     }
//   }
// }
